import type { LineItem } from "@graphql/generated/types";
import { useGetOffers } from "@hooks/useGetOffers";
import {
    editDiscountKey,
    getAllCartDiscounts,
    getProductOfferIds,
} from "@lib/utils/cart-utility/cartUtility";

export const useGetAllOffers = (item: LineItem) => {
    const allCartLevelDiscounts = getAllCartDiscounts(item);
    const allProductLevelOfferIds = getProductOfferIds(item);
    const filterNonStrings = (item?: string | null): item is string => !!item;

    const offerIds = Array.from(
        new Set([
            ...allCartLevelDiscounts
                .filter((discount) => !!discount.key)
                .map((discount) => editDiscountKey(discount.key as string))
                .filter(filterNonStrings),
            ...allProductLevelOfferIds,
        ])
    );

    return useGetOffers({
        offerIds,
    });
};
